import React, { useContext, useEffect, useState, useCallback } from "react";
import { TranslatorContext } from "../../context/Translator";
import { Row, Col } from "react-bootstrap";
import { LabelFieldComponent } from "../../components/fields";
import { ButtonComponent } from "../../components/elements";
import PageLayout from "../../layouts/PageLayout";
import { toast } from 'react-toastify';
import { useParams, useNavigate } from "react-router-dom";
import { showUserType } from "../../APIs/UserTypeRequests";

export default function UserTypeDetailsPage() {
    const { t } = useContext(TranslatorContext);
    const { id } = useParams();
    const navigate = useNavigate();
    
    // State management
    const [userType, setUserType] = useState(null);
    const [loading, setLoading] = useState(true);
   
    
    // Form states
    const [name, setName] = useState('');
    
   
    // Fetch user type details
    const fetchUserType = useCallback(async () => {
        try {
            setLoading(true);
            const response = await showUserType(id);
            const data = response.data.data || response.data;
            setUserType(data);
            setName(data.name || '');
        } catch (error) {
            console.error('Error fetching user type:', error);
            toast.error(t('error_fetching_data') || 'Error fetching data');
            navigate('/user-types');
        } finally {
            setLoading(false);
        }
    }, [id, t, navigate]);

    useEffect(() => {
        if (id) {
            fetchUserType();
        }
    }, [id, fetchUserType]);



   

    if (loading) {
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className="mc-card-body text-center">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">{t('loading') || 'Loading...'}</span>
                                </div>
                                <p className="mt-2">{t('loading_user_type') || 'Loading user type...'}</p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </PageLayout>
        );
    }

    if (!userType) {
        return (
            <PageLayout>
                <Row>
                    <Col xl={12}>
                        <div className="mc-card">
                            <div className="mc-card-body text-center">
                                <i className="fas fa-exclamation-triangle fa-3x text-warning mb-3"></i>
                                <h5>{t('user_type_not_found') || 'User Type Not Found'}</h5>
                                <p className="text-muted">{t('user_type_not_found_description') || 'The requested user type could not be found.'}</p>
                                <ButtonComponent 
                                    className="mc-btn primary"
                                    icon="arrow_back"
                                    text={t('back_to_list') || 'Back to List'}
                                    onClick={() => navigate('/user-types')}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </PageLayout>
        );
    }

    return (
        <PageLayout>
            <Row>
                <Col xl={12}>
                    <div className="mc-card">
                        <div className='mc-breadcrumb'>
                            <h3 className="mc-breadcrumb-title">
                                {t('user_type_details') || 'User Type Details'}: {userType.name}
                            </h3>
                        </div>
                    </div>
                </Col>
                
                {/* User Type Information */}
                <Col xl={12}>
                    <div className="mc-card">
                        <div className="mc-card-header">
                            <h4 className="mc-card-title">{t('user_type_information') || 'User Type Information'}</h4>

                        </div>
                        
                        <div className="mc-card-body">
                            <Row>
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">{t('id') || 'ID'}:</label>
                                        <div className="form-control-static">
                                            <strong>#{userType.id}</strong>
                                        </div>
                                    </div>
                                </Col>
                                
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">{t('created_at') || 'Created At'}:</label>
                                        <div className="form-control-static">
                                            {new Date(userType.created_at).toLocaleString()}
                                        </div>
                                    </div>
                                </Col>
                                
                                <Col md={12}>
                                    <div className="form-group">
                                        <label className="form-label">{t('name') || 'Name'}:</label>
                                        <div className="form-control-static">
                                            <h5>{userType.name}</h5>
                                        </div>
                                    </div>
                                </Col>
                                
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">{t('role') || 'Role'}:</label>
                                        <div className="form-control-static">
                                            {userType ? (
                                                <span className="badge bg-primary">{userType.role_name}</span>
                                            ) : (
                                                <span className="text-muted">{t('no_role_assigned') || 'No role assigned'}</span>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                
                                <Col md={6}>
                                    <div className="form-group">
                                        <label className="form-label">{t('superior_user_type') || 'Superior User Type'}:</label>
                                        <div className="form-control-static">
                                            {userType ? (
                                                <span className="badge bg-secondary">{userType.superior_name}</span>
                                            ) : (
                                                <span className="text-muted">{t('no_superior_assigned') || 'No superior assigned'}</span>
                                            )}
                                        </div>
                                    </div>
                                </Col>
                                
                            </Row>
                        </div>
                    </div>
                </Col>

            </Row>

            
        </PageLayout>
    );
}
